import { Content } from "@/components/Content";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";
import { getSimplePages } from "@/getters/getSimplePages";

// Page Builder Components
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { BuilderContentBlocks } from "@/ui/BuilderContentBlocks";
import { getDynamicPageStaticProps } from "@/functions/getDynamicPageStaticProps";
import dynamicPages from "@/../.sourceflow/dynamic_pages.json";

export default function Page({ content, isBuilder, seo, title, canonical, data, prefix }) {
  return isBuilder ? (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title?.length > 0 ? seo.title : title}
        canonical={seo?.canonical?.length > 0 ? seo.canonical : canonical}
      />
      <BuilderContentBlocks data={data} prefix={prefix} />
    </>
  ) : (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");

  // Prefer dynamic builder page if it exists
  const builderPage = dynamicPages.find((p) => p.url_slug === url_slug);
  if (builderPage) {
    return getDynamicPageStaticProps({ page: builderPage, url_slug });
  }

  // Fallback to simple static page
  const page = getSimplePages({ url_slug });
  return {
    props: {
      meta: {
        title: createTitle(page.title),
      },
      content: [
        { component: "Banner", props: { className: "", ...page } },
        { component: "Text", props: { TextFormId: page?.form_id ?? null, className: "", ...page } },
        { component: "Connecting", props: { className: "bg-grey-light" } },
      ],
    },
  };
}

export async function getStaticPaths() {
  // Get all builder page paths (excluding root)
  const builderPaths = dynamicPages
    .filter((i) => !["/"].includes(i.url_slug))
    .map((i) => ({
      params: { url_slugs: i.url_slug.split("/") },
    }));

  // Get all simple page paths
  const simplePagePaths = (await getSimplePages()).map((i) => ({
    params: { url_slugs: i.url_slug.split("/") },
  }));

  return {
    paths: [...builderPaths, ...simplePagePaths],
    fallback: false,
  };
}
